/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import api, { reportApiError } from "../api";
import get from "lodash/get";

const qs = require("qs");

export default {
  state: {
    poolData: [],
    destinationData: [],
  },
  getters: {
    getPoolData(state) {
      return state.poolData;
    },
    getDestinationData(state) {
      return state.destinationData;
    },
  },
  mutations: {
    ADD_POOL_DATA(state, data) {
      state.poolData = data;
    },
    ADD_DESTINATION_DATA(state, data) {
      state.destinationData = data;
    },
  },
  actions: {
    LOAD_POOL_DATA({ commit, rootState }, payload) {
      const data = {
        token: rootState.token,
        clientid: rootState.clientid
      };
      if (payload && payload.hasOwnProperty("timezone")) {
        data.timezone = payload.timezone;
      }
      commit("SET_DATA_SCHEDULE", "LOADING");
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify(data)
        )
        .then((response) => {
          if (response !== null) {
            const geofencesByClientid = get(response, `data.data.${rootState.clientid}`, []);
            const geofences = geofencesByClientid.reduce((acc, item) => {
              if (item && item.geofences) {
                return acc.concat(item.geofences);
              }
              return acc;
            }, []);
            commit("ADD_POOL_DATA", geofences);
            commit("SET_DATA_SCHEDULE", "LOADED");
          }
        })
        .catch((error) => {
          reportApiError(error, "get_geofences");
          commit("SET_DATA_SCHEDULE", "ERROR");
        });
    },
    LOAD_DESTINATION_DATA({ commit, rootState }, payload) {
      commit("SET_DATA_SCHEDULE", "LOADING");
      const data = {
        token: rootState.token,
        clientid: rootState.clientid
      };
      if (payload && payload.hasOwnProperty("timezone")) {
        data.timezone = payload.timezone;
      }
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_geofences`,
          qs.stringify(data)
        )
        .then((response) => {
          const byClientid = get(response, `data.data.${rootState.clientid}`, {});
          const geofences = [
            ...get(byClientid, '1.geofences', []),
            ...get(byClientid, '2.geofences', []),
          ];
          commit("ADD_DESTINATION_DATA", geofences);
          commit("SET_DATA_SCHEDULE", "LOADED");
        })
        .catch((error) => {
          reportApiError(error, "get_geofences");
          commit("SET_DATA_SCHEDULE", "ERROR");
        });
    },
  },
};
